import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { BaseService } from './base.service';

const headers = new HttpHeaders({
  'Content-Type': 'application/json'
})
@Injectable({
  providedIn: 'root'
})
export class StudentService {
  
  constructor(private http: HttpClient,private base: BaseService) { }

  private baseUrl = this.base._baseUrl + '/student'

  getCourseListsByDeptIdProgSemester(academicyear: string, deptid: number, level: string, programme: string, semester: string) {
    return this.http.get<any>(this.baseUrl +
      `/courseform?academicyear=${academicyear}&deptid=${deptid}&level=${level}&programme=${programme}&semester=${semester}`)
      .pipe(
        catchError(err => this.base.errorHandler(err))
      )
  }
}
